import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { delay: { type: Number, default: 300 } }
  static targets = ["input"]

  connect() {
    this.timeout = null
    this.boundSubmit = this.submit.bind(this)
  }

  search(event) {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    this.timeout = setTimeout(() => {
      this.submit()
    }, this.delayValue)
  }

  submit() {
    // Get current URL parameters
    const url = new URL(window.location.href)
    const params = new URLSearchParams(url.search)
    
    // Update search parameter if input has value, otherwise remove it
    if (this.inputTarget.value.trim()) {
      params.set(this.inputTarget.name, this.inputTarget.value.trim())
    } else {
      params.delete(this.inputTarget.name)
    }
    
    // Remove page parameter when searching
    params.delete('page')
    
    // Use Turbo to navigate - this will maintain the SPA feel
    Turbo.visit(`${url.pathname}?${params.toString()}`, { 
      action: 'replace',
      frame: 'products_list'
    })
  }
} 
